/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Whether the customer says security or collateral is available
 */
export type SecurityAvailability = typeof SecurityAvailability[keyof typeof SecurityAvailability];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SecurityAvailability = {
  YES: 'YES',
  NO: 'NO',
  TO_BE_CONFIRMED: 'TO_BE_CONFIRMED',
} as const;
